import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { CustomerMovement, CustomerVM, OperationResult } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  customerApi = `${environment.apiUrl}/Customer`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  create(customer: CustomerVM) {
    return this.http.post(this.customerApi, customer).pipe(
      map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          this.alertify.success("Cliente creado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  update(customer: CustomerVM) {
    return this.http.put(this.customerApi, customer).pipe(
      map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          this.alertify.success("Cliente editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  updateCreditStatus(customer: CustomerVM) {
    const uri = `${this.customerApi}/UpdateCreditStatus`;
    return this.http.put(uri, customer).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          if (customer.HasCredit) {
            this.alertify.success("Cliente con crédito agregado:");
          } else {
            this.alertify.success("Cliente sin crédito eliminado:");
          }
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  updateCredit(customer: CustomerVM) {
    const uri = `${this.customerApi}/UpdateCreditStatus`;
    return this.http.put(uri, customer).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Cliente editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  delete(id: string) {
    const uri = `${this.customerApi}?uuid=${id}`;
    return this.http.delete(uri).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Cliente eliminado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  activate(customer: CustomerVM) {
    const uri = `${this.customerApi}/ActivateRecord`;
    return this.http.put(uri, customer).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Cliente activado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.customerApi).pipe(
      map((response: OperationResult<CustomerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getDeleted() {
    const uri = `${this.customerApi}/GetDeleted`;;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CustomerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getCreditCustomers() {
    const uri = `${this.customerApi}/GetCreditCustomers`;;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CustomerVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.customerApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CustomerVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getCustomerMovements(customerId: string) {
    const uri = `${this.customerApi}/GetCustomerMovements?customerId=${customerId}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<CustomerMovement[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
